<div class="moorl-abstract-cms-listing-config">
    <moorl-form
        v-if="!isLoading"
        :item="element.config"
        :componentName="element.type"
        :entity="cmsElementEntity.entity"
        :mapping="cmsElementMapping"
        :hideDisabledFields="true"
        pathAppend="value"
    />
    <moorl-support-link path="/MoorlFoundation/listing/"/>
</div>
